import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("linearGradient", {
  fill: "currentColor",
  id: "a",
  gradientUnits: "userSpaceOnUse",
  x1: "100",
  y1: "616.432",
  x2: "100",
  y2: "756",
  gradientTransform: "translate(0 -566)"
}, [
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "0"
  }),
  /*#__PURE__*/_createElementVNode("stop", {
    fill: "currentColor",
    offset: "1"
  })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M164.2 177.1V39.9c0-1.8-1.4-3.2-3.2-3.2h-35.4V13.2c0-1.8-1.4-3.2-3.2-3.2H38.9c-1.8 0-3.2 1.4-3.2 3.2v163.9H22.9V190h154.3v-12.9h-13zm-89.9-25.7H61.4v-12.9h12.9v12.9zm0-25.7H61.4v-12.9h12.9v12.9zm0-25.7H61.4V87.1h12.9V100zm0-25.7H61.4V61.4h12.9v12.9zm0-25.7H61.4V35.7h12.9v12.9zM100 151.4H87.1v-12.9H100v12.9zm0-25.7H87.1v-12.9H100v12.9zm0-25.7H87.1V87.1H100V100zm0-25.7H87.1V61.4H100v12.9zm0-25.7H87.1V35.7H100v12.9zm38.6 102.8h-12.9v-12.9h12.9v12.9zm0-25.7h-12.9v-12.9h12.9v12.9zm0-25.7h-12.9V87.1h12.9V100zm0-25.7h-12.9V61.4h12.9v12.9z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}